import { useEffect, useState } from 'react';
import './loader.scss';
import { getClassnames } from 'src/utils/utils';

interface LoaderProps {
    fullscreen?: boolean;
    visible: boolean;
    classNames?: string;
}

export const Loader = ({ classNames, fullscreen, visible }: LoaderProps) => {
    const [hiding, setHiding] = useState(false);
    useEffect(() => {
        if (!visible) {
            setHiding(true);
        } else {
            setHiding(false);
        }
    }, [visible]);
    const onTransitionEnd = () => {
        setHiding(false);
    }

    const classNamesContainer = getClassnames({
        [classNames]: !!classNames,
      });

    let className = fullscreen ? 'loader-container loader-fullscreen' : 'loader-container';
    if (hiding) {
        className += ' hiding';
    } else if (!visible) {
        className += ' hidden';
    }
    return (
        <div className={`${classNamesContainer} ${className}`} onTransitionEnd={onTransitionEnd} data-testid="loader-container">
            <div className="loader"></div>
        </div>
    );
}